import { render, staticRenderFns } from "./settings-organization-team-members.vue?vue&type=template&id=1f9e4f9a&scoped=true&"
import script from "./settings-organization-team-members.vue?vue&type=script&lang=js&"
export * from "./settings-organization-team-members.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9e4f9a",
  null
  
)

export default component.exports